












































import Vue, { PropType, VueConstructor } from 'vue';
import format from 'date-fns/format';

import { Room } from '@/views/List/typings';
import { RoomLog } from '@/views/Room/typings';
import { Logined } from '@/views/Home/typings';

interface LocalBindings {
	todayOfWeek: string;
}

export default (Vue as VueConstructor<Vue & LocalBindings>).extend({
	name: 'RoomsVue',

	props: {
		rooms: {
			type: Array as PropType<Room[]>,
			default: null,
		},

		enterChat: {
			type: Function as PropType<() => Promise<void>>,
			default: null,
		},

		showLast: {
			type: Function as PropType<(id: number, type: string) => string>,
			default: null,
		},

		roomLog: {
			type: Object as PropType<RoomLog>,
			default: null,
		},

		logined: {
			type: Object as PropType<Logined>,
			default: null,
		},

		showUnreadCount: {
			type: Function as PropType<(id: number) => number>,
			default: null,
		},
	},

	computed: {
		todayOfWeek() {
			return format(new Date(), 'EEE');
		},
	},
});
